<template>
    <section class="pt-10" id="destination" style="background: #f8f9fa;">
        <div class="container">
            <!-- Place Detail Header with Fade-In/Fade-Out Carousel and Dots -->
            <div class="place-detail text-center mb-5">
                <div class="card shadow border-0">
                    <div class="card-body">
                        <h2 class="mb-2 mt-2 fw-bold text-primary" style="text-align: left;">{{ place.name }}</h2>
                    </div>
                    <div id="placeCarousel" class="carousel slide carousel-fade" data-bs-ride="carousel"
                        data-bs-interval="3000">
                        <div class="carousel-inner">
                            <div v-for="(image, index) in galleryImages" :key="index" class="carousel-item"
                                :class="{ active: index === 0 }">
                                <img :src="imageBaseUrl  + image" class="d-block w-100"
                                    alt="Cover Image" style="object-fit: cover; height: 300px;">
                            </div>
                        </div>

                        <!-- Indicators Section -->
                        <div class="carousel-indicators-wrapper text-center py-2">
                            <div class="carousel-indicators d-flex justify-content-center">
                                <button v-for="(image, index) in galleryImages" :key="index" type="button"
                                    :data-bs-target="'#placeCarousel'" :data-bs-slide-to="index"
                                    :class="{ active: index === 0 }" aria-current="true"
                                    aria-label="'Slide ' + (index + 1)">
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <!-- Location Section Full Width -->
            <div class="row mb-4">
                <div class="col-12">
                    <div class="card shadow border-0">
                        <div class="card-body">

                            <div class="row">
                                <div class="col-md-6 mb-3">
                                    <h4 class="card-title text-primary mb-4">Description of Destination</h4>
                                    <p class="">
                                        <span>Arugam Bay, known locally as "Arugam Kudah", is situated on the Indian
                                            Ocean in the dry zone of Sri Lanka's southeast coast, and a historic
                                            settlement of the ancient Batticaloa Territory. </span>
                                        <!-- <span>{{ place.placeAddress }}</span> -->

                                    </p>
                                    <p>
                                        A world-class wave for surfers but that can be inconsistent at high season. It's
                                        better checking the surf forecast before! The bay is wild and clean with
                                        charming fishing boats and local beach huts where to cool down. The point is the
                                        main break and deliver the best swell. There are other famous breaks around,
                                        like Komari or Panama Point. The local bars and restaurants are mostly very good
                                        with happy hour and nightlife. It's one of the best value in Sri Lanka for beach
                                        lovers. Fabulous!
                                    </p>
                                    <!-- <p class="d-flex justify-content-between">
                                        <strong>Latitude:</strong> <span>{{ place.placeLattitude }}</span>
                                    </p>
                                    <p class="d-flex justify-content-between">
                                        <strong>Longitude:</strong> <span>{{ place.placeLongtitude }}</span>
                                    </p>
                                    <p class="d-flex justify-content-between">
                                        <strong>Contact Number:</strong> <span>{{ place.placePhNo || 'Not available'
                                            }}</span>
                                    </p>
                                    <p class="d-flex justify-content-between">
                                        <strong>Email:</strong> <span>{{ place.email || 'Not available' }}</span>
                                    </p> -->
                                </div>

                                <div class="col-md-6">
                                    <div id="map" class="map-container" style="height: 350px;"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <!-- Details and Booking Calendar Row -->
            <div class="row mb-4">
                <!-- Place Details Section -->
                <div class="col-lg-6 mb-4">
                    <div class="card shadow border-0 h-100">
                        <div class="card-body">
                            <h4 class="card-title text-primary mb-4" style="text-align: left;">Destination Details
                            </h4>
                            <ul class="list-group list-group-flush">
                                <!-- <li class="list-group-item d-flex justify-content-between">
                                    <strong>Category:</strong> <span>{{ place.cat }}</span>
                                </li> -->
                                <!-- <li class="list-group-item d-flex justify-content-between">
                                    <strong>Country:</strong> <span>{{ place.country }}</span>
                                </li> -->
                                <li class="list-group-item d-flex justify-content-between">
                                    <strong>Province:</strong> <span>{{ place.district }}</span>
                                </li>
                                <li class="list-group-item d-flex justify-content-between">
                                    <strong>City:</strong> <span>{{ place.city }}</span>
                                </li>


                                <!-- <li class="list-group-item d-flex justify-content-between">
                                    <strong>Created By:</strong> <span>{{ place.createdBy }}</span>
                                </li> -->
                                <li class="list-group-item d-flex justify-content-between">
                                    <strong>Visiting Time:</strong>
                                    <span>{{ place.openType === 1 ? '24 Hrs Open' : 'Closed' }}</span>
                                </li>
                                <!-- <li class="list-group-item d-flex justify-content-between">
                                    <strong>Sub Category:</strong> <span>{{ place.subCat }}</span>
                                </li> -->
                            </ul>
                        </div>
                    </div>
                </div>
                <!-- Booking Calendar Component Section -->
                <div class="col-lg-6 mb-3">
                    <div class="card shadow border-0">
                        <div class="card-body">
                            <h4 class="card-title text-primary" style="text-align: left;">Find Best Organizer</h4>
                            <div class="booking-calendar container">
                                <form @submit.prevent="submitBooking">
                                    <div class="mb-3 mt-0">
                                        <div class="row">
                                            <div class="col-md-6">
                                                <label for="adults" class="form-label">Adults</label>
                                                <input type="number" v-model="adults" id="adults" class="form-control"
                                                    min="0" required />
                                                <small class="text-danger text-center" id="clientError"></small>
                                            </div>
                                            <div class="col-md-6">
                                                <label for="children" class="form-label">Children</label>
                                                <input type="number" v-model="children" id="children"
                                                    class="form-control" min="0" required />
                                                <small class="text-danger text-center" id="childError"></small>
                                            </div>
                                        </div>

                                    </div>

                                    <div class="mb-3 row">
                                        <div class="col-md-6">
                                            <label for="check-in" class="form-label">Arrival</label>
                                            <input type="date" v-model="checkIn" class="form-control" :min="today"
                                                @change="updateCheckOutMin" id="checkIn" />
                                            <small class="text-danger" id="arrivalError"></small>
                                        </div>

                                        <div class="col-md-6">
                                            <label for="check-out" class="form-label">Departure</label>
                                            <input type="date" v-model="checkOut" class="form-control"
                                                :min="minCheckOutDate" id="checkOut" />
                                            <small class="text-danger" id="departureError"></small>
                                        </div>
                                    </div>

                                    <div class="mb-3">
                                        <p>Total Days: {{ totalDays }}</p>
                                    </div>

                                    <button type="submit" class="col-12 btn btn-primary">Find</button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Gallery Section -->
            <div class="row mb-4">
                <div class="col-12">
                    <div class="card shadow border-0">
                        <div class="card-body">
                            <h4 class="card-title text-primary text-left mb-3">Gallery</h4>
                            <div v-if="galleryImages && galleryImages.length > 0">
                                <div class="row">
                                    <div v-for="(image, index) in galleryImages" :key="index" class="col-md-2 mb-3">
                                        <div class="Gallerycard h-100">
                                            <img :src="imageBaseUrl + image"
                                                class="card-img-top img-fluid gallery-image" alt="Gallery Image"
                                                @click="openModal(image)" style="cursor: pointer;" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-else>
                                <p class="text-center">No images available.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <!-- Modal for displaying enlarged images -->
            <div v-if="isModalOpen" class="modal fade show"
                style="display: block; position: fixed; top: 0; left: 0; width: 100%; height: 100%; z-index: 1050; background-color: rgba(0, 0, 0, 0.8);"
                tabindex="-1" role="dialog">
                <div class="modal-dialog modal-dialog-centered" role="document" style="max-width: 100%; width: auto;">
                    <div class="modal-content" style="border: none; background: transparent; text-align: center;">
                        <div class="modal-header" style="border: none; justify-content: flex-end;">
                            <button type="button" class="btn btn-secondary" @click="closeModal">X</button>
                        </div>
                        <div class="modal-body" style="padding: 0;">
                            <img :src="imageBaseUrl  + currentImage" class="img-fluid"
                                alt="Enlarged Image" style="max-height: 90vh; max-width: 90vw;" />
                        </div>
                    </div>
                </div>
            </div>



            <!-- User Comments Section -->
            <!-- <div class="row mb-4">
                <div class="col-12">
                    <div class="card shadow border-0">
                        <div class="card-body">
                            <h4 class="card-title text-primary">User Comments</h4>
                            <p>{{ place.userComments || 'No comments available.' }}</p>
                        </div>
                    </div>
                </div>
            </div> -->
        </div>
    </section>
</template>

<script>
import $ from 'jquery';
//import Swal from 'sweetalert2'; // Import SweetAlert2


export default {
    name: "PlaceDetail",

    data() {
        return {
            place: {},
            adults: 0,
            children: 0,
            checkIn: null,
            checkOut: null,
            isLoggedIn: false, // Add this property to track login status
            isModalOpen: false,
            currentImage: '',
            galleryImages: [],
        };
    },
    computed: {
        totalDays() {
            if (this.checkIn && this.checkOut) {
                const diffTime = Math.abs(new Date(this.checkOut) - new Date(this.checkIn));
                return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
            }
            return 0;
        },
        today() {
            const date = new Date();
            return date.toISOString().split("T")[0]; // Return date in YYYY-MM-DD format
        },
        minCheckOutDate() {
            // If checkIn is selected, set min checkOut date to the next day
            return this.checkIn ? this.addDays(this.checkIn, 1) : '';
        },
        imageBaseUrl() {
            return process.env.VUE_APP_URL + '/images/';
        }
    },
    mounted() {
        const placeId = this.$route.query.slug;
        if (placeId) {
            this.fetchPlaceDetails(placeId);
        }

        this.galleryImages = JSON.parse(this.place.placeImages || '[]'); // Make sure to parse the JSON correctly

        // Retrieve booking details from localStorage
        const bookingDetails = JSON.parse(localStorage.getItem('bookingDetails'));
        if (bookingDetails) {
            this.adults = bookingDetails.adults || 0;
            this.children = bookingDetails.children || 0;
            this.checkIn = bookingDetails.checkIn || null;
            this.checkOut = bookingDetails.checkOut || null;
        }
        localStorage.removeItem('bookingDetails');
    },
    methods: {
        fetchPlaceDetails(slug) {
            $.ajax({
                url: process.env.VUE_APP_API_URL +`/place/${slug}`,
                type: "GET",
                dataType: "json",
                success: (response) => {
                    this.place = response;
                    this.initMap(); // Initialize the map after fetching place details
                },
                error: (jqXHR, textStatus, errorThrown) => {
                    console.error("Error fetching place details:", textStatus, errorThrown);
                },
            });
        },
        openModal(image) {
            this.currentImage = image;
            this.isModalOpen = true;
        },
        closeModal() {
            this.isModalOpen = false;
        },
        initMap() {
            const latitude = parseFloat(this.place.placeLattitude);
            const longitude = parseFloat(this.place.placeLongtitude);

            const map = new google.maps.Map(document.getElementById('map'), {
                zoom: 15,
                center: { lat: latitude, lng: longitude },
            });

            new google.maps.Marker({
                position: { lat: latitude, lng: longitude },
                map: map,
                title: 'Location: ' + this.place.placeAddress,
            });
        },
        addDays(date, days) {
            const result = new Date(date);
            result.setDate(result.getDate() + days);
            return result.toISOString().split("T")[0]; // Return date in YYYY-MM-DD format
        },
        checkLoginStatus() {
            // Here you can implement your logic to check if the user is logged in
            // For example, you might check if a token exists in localStorage
            const token = localStorage.getItem('token');
            this.isLoggedIn = token !== null; // Set the login status based on token existence
        },
        submitBooking() {


            const clientError = $('#clientError');
            const childError = $('#childError');
            const arrivalError = $('#arrivalError');
            const departureError = $('#departureError');

            var checkIn = $('#checkIn').val().trim();
            var checkOut = $('#checkOut').val().trim();

            if (this.adults + this.children <= 0) {
                clientError.text('Have one person must for the booking.');
                return;
            }

            if (this.adults == 0) {
                clientError.text('');
                childError.text('we can not allowed children alone.');
                return;
            }

            if (checkIn == 0) {
                clientError.text('');
                childError.text('');
                arrivalError.text('Arrival date is must.');
                return;
            }
            if (checkOut == 0) {
                clientError.text('');
                childError.text('');
                arrivalError.text('');
                departureError.text('Departure date is must.');
                return;
            }

            const bookingDetails = {
                adults: this.adults,
                children: this.children,
                checkIn: this.checkIn,
                checkOut: this.checkOut,
            };

            this.checkLoginStatus(); // Check login status before proceeding

            if (!this.isLoggedIn) {
                // Store the original page and booking details in local storage
                localStorage.setItem('redirectPath', this.$route.fullPath);
                localStorage.setItem('bookingDetails', JSON.stringify({
                    adults: this.adults,  
                    children: this.children,
                    checkIn: this.checkIn,
                    checkOut: this.checkOut
                }));
                localStorage.setItem('placeDetails', JSON.stringify(this.place));
                // Redirect to the login page
                this.$router.push({ path: '/login' });
            }
            else{
                // Handle booking submission logic (e.g., send to API)
            console.log("Booking Details:", bookingDetails);
            // You can implement your API call here

            // Navigate to the booking page and pass booking details as query params
            this.$router.push({
                path: `/booking`,
                query: {
                    adults: this.adults,
                    children: this.children,
                    checkIn: this.checkIn,
                    checkOut: this.checkOut,
                    place: JSON.stringify(this.place)  // Serialize place object
                }
            });
            }

            
        },
        updateCheckOutMin() {
            // This method is no longer needed as we handle minCheckOutDate via computed property
        }
    },
    watch: {
        place(newValue) {
            if (newValue && newValue.placeImages) {
                this.galleryImages = JSON.parse(newValue.placeImages || '[]');
            }
        }
    }
};
</script>

<style scoped>
/* Add styles for the detail page */
.card-title {
    font-weight: bold;
}

.card {
    transition: transform 0.2s;
}

.card:hover {
    transform: scale(1.02);
}

/* Additional styling */
.container {
    max-width: 1200px;
}

.text-primary {
    color: #007bff;
    /* Bootstrap primary color */
}

.lead {
    font-size: 1.25rem;
    font-weight: 300;
}

.mb-4 {
    margin-bottom: 1.5rem !important;
}

/* Responsive adjustments */
@media (max-width: 576px) {
    .text-primary {
        font-size: 1.5rem;
        /* Adjust title size for smaller screens */
    }
}

@media (min-width: 768px) {
    #map {
        height: 300px;
    }
}

@media (max-width: 768px) {
    #map {
        height: 200px;
        /* Reduce map height for smaller screens */
    }
}

.map-container {
    width: 100%;
    border: 1px solid #ccc;
    /* Optional: for visual clarity */
}

@media (max-width: 768px) {
    .map-container {
        height: 200px;
        /* Adjust height for smaller screens */
    }
}

.booking-calendar {
    max-width: 600px;
    margin: auto;
    padding: 20px;

}

.Gallerycard {
    /* Ensure all cards have the same height */
    height: 250px;
    /* Adjust height as needed */
    overflow: hidden;
    /* Hide overflow to maintain card size */
}

.gallery-image {
    width: 100%;
    /* Make image take the full width of the card */
    height: 150px;
    /* Set a fixed height for the images */
    object-fit: cover;
    /* Ensure images cover the area while maintaining aspect ratio */
}

.modal {
    transition: opacity 0.3s ease;
}

.modal.fade {
    opacity: 0;
}

.modal.fade.show {
    opacity: 1;
}

.carousel-indicators {
    right: unset;
    margin-left: 0rem;
}

.carousel-indicators {
    position: relative;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 2;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    padding: 0;
    margin-right: 15%;
    margin-bottom: 5px;
    margin-left: 15%;
    list-style: none;
}
</style>